import { createSlice } from "@reduxjs/toolkit";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import { getLprEnquiries } from "../../../api/lprEnquiryAPI";

export const lprEnquirySlice = createSlice({
  name: "lprEnquiry",
  initialState: {
    enquiries: [],
    pagination: {},
    page: 0,
    rowsPerPage: 100,
    sort: "desc",
    sortBy: "createdAt",
    selectedId: null,
    selectedEnquiry: null,
    detailModalOpen: false,
    successMessage: "",
    errorMessage: "",
  },
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = action.payload;
    },
    setSort: (state, action) => {
      state.sort = action.payload;
    },
    setSortBy: (state, action) => {
      state.sortBy = action.payload;
    },
    setEnquiries: (state, action) => {
      state.enquiries = action.payload;
      state.status = "success";
    },
    setSelectedId: (state, action) => {
      state.selectedId = action.payload;
    },
    setSelectedEnquiry: (state, action) => {
      state.selectedEnquiry = action.payload;
    },
    showDetailModal: (state, action) => {
      state.detailModalOpen = action.payload;
    },
    setSuccessMessage: (state, action) => {
      state.successMessage = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
  },
});

export const {
  setPage,
  setRowsPerPage,
  setPagination,
  setSort,
  setSortBy,
  setEnquiries,
  setSelectedId,
  setSelectedEnquiry,
  showDetailModal,
  setSuccessMessage,
  setErrorMessage,
} = lprEnquirySlice.actions;

export const selectState = (state) => state.lprEnquiry;

export const handleGetEnquiries = () => async (dispatch, getState) => {
  dispatch(showLoading());
  const state = getState();

  try {
    const response = await getLprEnquiries(
      state.lprEnquiry.page,
      state.lprEnquiry.rowsPerPage,
      state.lprEnquiry.sort,
      state.lprEnquiry.sortBy
    );
    const { items = [], ...pagination } = response.data;

    dispatch(setPagination(pagination));
    dispatch(setEnquiries(items));
  } catch (error) {
    dispatch(setErrorMessage(error.message));
  } finally {
    dispatch(hideLoading());
  }
};

export default lprEnquirySlice.reducer;
